import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//引入element-ui js css
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
//Passive Event Listeners 反正就是去掉一个提示 具体搜前面的英文
import 'default-passive-events'

//引入VueResource
import VueResource from 'vue-resource'
//注册全局组件 头部的menu
import HandMenu from "./components/HandMenu"

Vue.use(VueResource);
//添加全局组件
Vue.component("HandMenu", HandMenu);
Vue.config.productionTip = false;


const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default vm;